import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as yup from "yup";
import DataForm from "components/UI/form/DataForm";
import { addComplexDataAction, fetchDataAction, reset, setAlert } from "store/features/coreSlice";
import PropTypes from "prop-types";
import UpdateRecord from "helpers/compare";
import { useTranslation } from "react-i18next";
import dataVal from "../../dataVal.json";

const PageForm = ({ updateHandlerVal, pageNum, url }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { formproducts, formpublisher, limit, formlibraries, inventoryImgList, formdistributions } =
    useSelector((state) => state.core);
  const { userInfo } = useSelector((state) => state.auth);

  const [data, setData] = useState([]);
  const [initialValues, setInitialValues] = useState(dataVal.initialValues);
  const [publisherId, setPublisherId] = useState(null);
  const [bookId, setBookId] = useState(null);
  const [libraryId, setLibraryId] = useState(null);

  const [filesData, setFilesData] = useState(undefined);

  useEffect(() => {
    setFilesData(inventoryImgList);
  }, [inventoryImgList]);

  const orgData = () => {
    setData([
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "publisher",
        id: "publisher",
        label: "publisher",
        data: formpublisher,
        size: 4,
        title: "publisher",
      },
      {
        type: "Select",
        optionTitle: "arabic_title",
        name: "book_id",
        id: "book_id",
        label: "book_id",
        data: formproducts,
        size: 4,
        title: "book",
      },
      {
        type: "Select",
        optionTitle: "title",
        name: "library_id",
        id: "library_id",
        label: "library_id",
        data: formlibraries,
        size: 4,
        title: "libraries",
      },
      {
        type: "Select",
        optionTitle: "distribution_date",
        optionTitle1: "notes",
        name: "distribution_id",
        id: "distribution_id",
        label: "distribution_id",
        data: formdistributions,
        size: 4,
        title: "distribution",
      },
      {
        type: "TextField",
        name: "count",
        id: "count",
        label: "count",
        size: 4,
        title: "count",
      },
      {
        type: "Date",
        name: "inventory_date",
        id: "inventory_date",
        label: "inventory_date",
        size: 4,
        title: "inventoryDate",
      },
      {
        type: "TextArea",
        name: "notes",
        id: "notes",
        label: "notes",
        maxRows: 4,
        minRows: 4,
        size: 6,
        title: "notes",
      },
      {
        type: "MImg",
        name: "files",
        id: "files",
        label: "files",
        size: 6,
        title: "image",
      },
    ]);
  };

  const resetForm = () => {
    setPublisherId(null);
    setBookId(null);
    setPublisherId(null);
    setLibraryId(null);
    setFilesData(undefined);
  };

  const setFieldSelectedValue = (name, values) => {
    if (name === "publisher") {
      setPublisherId(values.id);
      dispatch(
        fetchDataAction({
          url: `items/products?fields=id,arabic_title,publisher&filter[publisher]=${values.id}`,
          varName: "formproducts",
        })
      );
    }

    let urlVal;
    if (name === "book_id") {
      setBookId(values.id);
      urlVal = `items/distributions?fields=id,distribution_date,notes,count&filter[store_id.buying_id.book_id]=${values.id}`;
      if (libraryId) urlVal += `&filter[library_id]=${libraryId}`;
      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formdistributions",
        })
      );
    } else if (name === "library_id") {
      setLibraryId(values.id);
      urlVal = `items/distributions?fields=id,distribution_date,notes,count&filter[library_id]=${values.id}`;
      if (bookId) urlVal += `&filter[store_id.buying_id.book_id]=${bookId}`;
      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formdistributions",
        })
      );
    }
  };

  const onChangeSelectInputs = (name, text) => {
    if (name === "publisher") {
      dispatch(
        fetchDataAction({
          url: `items/publisher?fields=id,arabic_title&filter[arabic_title][${
            text ? `contains]=${text}` : "nempty]=true"
          }&limit=${limit}`,
          varName: "formpublisher",
        })
      );
    }

    let urlVal;
    if (name === "book_id") {
      urlVal = `items/products?fields=id,arabic_title&filter[arabic_title][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (publisherId) urlVal += `&filter[publisher]=${publisherId}`;

      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formproducts",
        })
      );
    }

    if (name === "library_id") {
      urlVal = `items/libraries?filter[title][${
        text ? `contains]=${text}` : "nempty]=true"
      }&limit=${limit}`;
      if (!userInfo.all_libraries) urlVal += `&filter[users.user_id][eq]=${userInfo.id}`;
      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formlibraries",
        })
      );
    }

    if (name === "distribution_id") {
      urlVal = `items/distributions?fields=id,distribution_date,notes,count&filter[distribution_date][eq]=${text}&limit=${limit}`;
      if (bookId) urlVal += `&filter[store_id.buying_id.book_id]=${bookId}`;
      if (libraryId) urlVal += `&filter[library_id]=${libraryId}`;

      dispatch(
        fetchDataAction({
          url: urlVal,
          varName: "formdistributions",
        })
      );
    }
  };

  const getData = (dataNeeded) => {
    let urlVal;
    dataNeeded.forEach((element) => {
      if (element === "proposal")
        dispatch(
          fetchDataAction({
            url: `items/${element}?fields=id,cost,discount_percentage,is_dolar&filter[status]=published&limit=${limit}`,
            varName: `form${element}`,
          })
        );
      else if (element === "libraries") {
        urlVal = `items/libraries?limit=${limit}`;
        if (!userInfo.all_libraries) urlVal += `&filter[users.user_id][eq]=${userInfo.id}`;
        dispatch(
          fetchDataAction({
            url: urlVal,
            varName: `form${element}`,
          })
        );
      } else if (element === "distributions") {
        urlVal = `items/${element}?fields=id,distribution_date,notes,count,inventories.count,returns.count,inventories.id,count,store_id.place_id.title,store_id.place_id.id&limit=${limit}`;
        if (!userInfo.all_libraries)
          urlVal += `&filter[library_id.users.user_id][eq]=${userInfo.id}`;
        dispatch(
          fetchDataAction({
            url: urlVal,
            varName: `form${element}`,
          })
        );
      } else
        dispatch(
          fetchDataAction({
            url: `items/${element}?limit=${limit}`,
            varName: `form${element}`,
          })
        );
    });
  };

  const onUpdateHandler = (name, values, copy) => {
    if (values.distribution_id?.store_id?.buying_id?.book_id?.publisher) {
      setFieldSelectedValue(
        "publisher",
        values.distribution_id.store_id.buying_id.book_id.publisher
      );
      onChangeSelectInputs(
        "publisher",
        values.distribution_id.store_id.buying_id.book_id.publisher.arabic_title
      );
    }

    if (values.store_id?.buying_id?.book_id) {
      onChangeSelectInputs(
        "book_id",
        values.distribution_id.store_id.buying_id.book_id.arabic_title
      );
    }

    if (values.distribution_id.library_id) {
      onChangeSelectInputs("library_id", values.distribution_id.library_id.title);
    }

    if (values.distribution_id) {
      onChangeSelectInputs("distribution_id", values.distribution_id.distribution_date);
    }

    if (!copy)
      dispatch(
        fetchDataAction({
          url: `items/all_files?fields=id,collection,file_id.data.full_url,file_id.filesize,file_id.id,item_id,file_id.type,file_id.filename_download&filter[collection]=inventory&filter[item_id]=${values.id}`,
          varName: "inventoryImgList",
        })
      );

    setInitialValues({
      id: copy ? null : values.id,
      count: values.count,
      distribution_id: values.distribution_id,
      inventory_date: values.inventory_date,
      notes: values.notes,
      book_id: values.distribution_id.store_id.buying_id.book_id,
      publisher: values.distribution_id.store_id.buying_id.book_id.publisher,
      library_id: values.distribution_id.library_id,
    });
  };

  const setPayload = ({ files, ...values }) => {
    let count = 0;

    values.distribution_id.inventories?.forEach((element) => {
      if (element.id === values.id) {
        count -= element.count;
      }
      count += element.count;
    });
    values.distribution_id.returns?.forEach((element) => {
      count += element.count;
    });

    if (values.inventory_date < values.distribution_id.distribution_date) {
      dispatch(
        setAlert({
          status: "error",
          content: t("dateError"),
        })
      );
    } else if (values.distribution_id.count - (+values.count + count) >= 0) {
      const payloadData = {};
      const lastData = values.id ? UpdateRecord(values, initialValues) : values;

      Object.keys(lastData).forEach((key) => {
        if (lastData[key] && typeof lastData[key] === "object") payloadData[key] = lastData[key].id;
        else if (values.id || lastData[key]) payloadData[key] = lastData[key];
      });

      delete payloadData.book_id;
      delete payloadData.publisher;
      delete payloadData.library_id;

      const req = {
        id: values.id,
        file: files,
        origin: {
          data: Object.keys(payloadData).length === 0 ? null : payloadData,
          table: "inventory",
        },
        getInfo: {
          url: `${url}&meta=*&limit=${limit}&page=${pageNum}`,
          varName: "inventories",
        },
      };
      setInitialValues(values);

      dispatch(addComplexDataAction(req));
      resetForm();
    } else
      dispatch(
        setAlert({
          status: "error",
          content: t("countError"),
        })
      );
  };

  useEffect(() => {
    if (updateHandlerVal) {
      onUpdateHandler(updateHandlerVal.name, updateHandlerVal.value, updateHandlerVal.isCopy);
    } else {
      getData(dataVal.oterData);
    }
    return () => {
      resetForm();
      dispatch(reset({ alias: "form", data: dataVal.oterData }));
    };
  }, []);

  useEffect(() => {
    if (formproducts && formpublisher && formlibraries && formdistributions) {
      orgData();
    }
  }, [formproducts, formpublisher, formlibraries, formdistributions]);

  if (data.length === 0) {
    return null;
  }

  return (
    <DataForm
      yupObj={{
        publisher: yup.mixed("required").required("required").nullable(),
        book_id: yup.mixed("required").required("required").nullable(),
        library_id: yup.mixed("required").required("required").nullable(),
        distribution_id: yup.mixed("required").required("required").nullable(),
        inventory_date: yup.string("required").required("required").nullable(),
        count: yup
          .number("must be number")
          .required("required")
          .typeError("must be a number")
          .positive("must be greater than zero")
          .nullable(),
      }}
      imgList={filesData}
      resetData={resetForm}
      name="inventory"
      data={data}
      initialValues={initialValues}
      setPayload={setPayload}
      setFieldSelectedValue={setFieldSelectedValue}
      onChange={onChangeSelectInputs}
      defaultInitialValues={dataVal.initialValues}
    />
  );
};

PageForm.propTypes = {
  updateHandlerVal: PropTypes.objectOf(PropTypes.any),
  pageNum: PropTypes.number.isRequired,
  url: PropTypes.string.isRequired,
};

PageForm.defaultProps = {
  updateHandlerVal: null,
};
export default PageForm;
